import { render } from "./StatusOferta.vue?vue&type=template&id=9f3a34ce"
import script from "./StatusOferta.vue?vue&type=script&lang=js"
export * from "./StatusOferta.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ColorMetal\\cmportal-frontend-master\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__